// @ts-nocheck

import { CommonActionTypes } from '../../../types/actions/common';
import { type GenericAction } from '../../../types/redux';
import { ClientUpdaterActionTypes } from '../types/actions/clientUpdater';

export type ClientUpdaterState = {
  hasDismissTheWarnAtLeastOnce: boolean;
  isClientDeprecated: boolean;
  isClientUpdateMandatory: boolean;
};

export const clientUpdaterInitialState: ClientUpdaterState = {
  hasDismissTheWarnAtLeastOnce: false,
  isClientDeprecated: false,
  isClientUpdateMandatory: false,
};

const handledActionTypes = [ClientUpdaterActionTypes.DISMISS_UPDATE, CommonActionTypes.RECEIVE_ENTITIES];

const clientUpdaterReducer = (state: ClientUpdaterState = clientUpdaterInitialState, action: GenericAction) => {
  const { type: actionType } = action;

  if (~handledActionTypes.indexOf(actionType)) {
    const { payload: actionPayload = {} } = action;

    if (actionType === ClientUpdaterActionTypes.DISMISS_UPDATE) {
      return {
        ...state,
        hasDismissTheWarnAtLeastOnce: true,
      };
    }

    if (actionType === CommonActionTypes.RECEIVE_ENTITIES) {
      const { settings: actionPayloadSettings } = actionPayload;

      if (actionPayloadSettings) {
        let changed = false;
        let nextIsClientDeprecated = state.isClientDeprecated;
        let nextIsClientUpdateMandatory = state.isClientUpdateMandatory;

        const {
          clientIsDeprecated: clientIsDeprecatedFromSettings,
          clientUpdateIsMandatory: clientUpdateIsMandatoryFromSettings,
        } = actionPayloadSettings;

        if (
          typeof clientIsDeprecatedFromSettings === 'boolean' &&
          clientIsDeprecatedFromSettings !== state.isClientDeprecated
        ) {
          nextIsClientDeprecated = clientIsDeprecatedFromSettings;
          changed = true;
        }

        if (
          typeof clientUpdateIsMandatoryFromSettings === 'boolean' &&
          clientUpdateIsMandatoryFromSettings !== state.isClientUpdateMandatory
        ) {
          nextIsClientUpdateMandatory = clientUpdateIsMandatoryFromSettings;
          changed = true;
        }

        if (changed) {
          return {
            ...state,
            isClientDeprecated: nextIsClientDeprecated,
            isClientUpdateMandatory: nextIsClientUpdateMandatory,
          };
        }
      }

      return state;
    }
  }

  return state;
};

export default clientUpdaterReducer;
